// * Send report to backend
export async function sendReportToServer(payload) {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/qr_backend/error/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Absenden gescheitert");
    return res.json();
}